export type LogoutRequest = () => Promise<void>;
export type SessionReverificationRequest = () => Promise<void>;

let logoutRequest: LogoutRequest | null = null;
let sessionReverificationRequest: SessionReverificationRequest | null = null;

export function configureSessionLogout(request: LogoutRequest): void {
  logoutRequest = request;
}

export async function logoutCurrentSession(): Promise<void> {
  if (!logoutRequest) throw new Error("session logout is not configured");
  await logoutRequest();
}

export function configureSessionReverification(request: SessionReverificationRequest): void {
  sessionReverificationRequest = request;
}

export async function reverifyCurrentSession(): Promise<void> {
  if (!sessionReverificationRequest) throw new Error("session re-verification is not configured");
  await sessionReverificationRequest();
}

export function clearSessionLogout(): void {
  logoutRequest = null;
}

export function clearSessionReverification(): void {
  sessionReverificationRequest = null;
}
